import { Modal } from "react-bootstrap";
import ThemedModal from "../../../@ui/Modal/ThemedModal";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";

interface DeleteBannerMessageModalProps {
  onHide: () => void;
  onDelete: (id: number) => void;
  id: number;
  show: boolean;
}

const DeleteBannerMessageModal = ({
  show,
  onHide,
  onDelete,
  id,
}: DeleteBannerMessageModalProps) => {
  return (
    <ThemedModal centered show={show} onHide={onHide} backdrop="static">
      <Modal.Header className="bg-secondary text-white" closeButton>
        <StyledModalTitle>Change Currency</StyledModalTitle>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this banner message?
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary text-white" onClick={onHide}>
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={() => {
            onDelete(id);
            onHide();
          }}
        >
          Delete
        </button>
      </Modal.Footer>
    </ThemedModal>
  );
};

export default DeleteBannerMessageModal;
